module.exports = __webpack_public_path__ + "static/media/unico-auto-pecas.83a65702.png";